export const PLAN_SELECTED = "subscription.PLAN_SELECTED"
export const CHANGE_PERIOD = "subscription.CHANGE_PERIOD"
export const CHANGE_TOTAL_PRICE = "subscription.CHANGE_TOTAL_PRICE"
export const CHANGE_PRICE = "subscription.CHANGE_PRICE"

